import React from 'react';

import Presentation, { Props as PresentationProps } from './Presentation';

const ForgotPassword = (props: PresentationProps) => <Presentation {...props} />;

export default ForgotPassword;
